import { Outlet } from "react-router-dom";
import useRootProperties from "../../../hooks/useRootProperties";
import secondaryComponents from "../../secondaryComponents";

export const RootAppHelper = () => {
  const { isLoading } = useRootProperties();

  return (
    <secondaryComponents.LoaderHelper classNames={"mt-5"} isLoading={isLoading}>
      <Outlet />
    </secondaryComponents.LoaderHelper>
  );
};
